// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { useRoles } from '../verRolesContext';
import { CircularProgress, Divider, List, ListItem, ListItemText, Typography } from '@mui/material';
import { useBody } from '../../Body/state/BodyContext';

export default function VerTodosRoles() {
    const { getRoles, roles } = useRoles();
    const [loading, setLoading] = useState(false);
    const { setMessage } = useBody();

    const fetchRoles = async () => {
        setLoading(true);
        try {
            await getRoles();
        } catch (error) {
            console.error("Error obteniendo todos los roles:", error);
            setMessage("Error obteniendo todos los roles");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchRoles();
    }, []);

    return (
        <>
            <Typography variant="h6" gutterBottom>
                Todos los Roles
            </Typography>

            <Divider style={{ marginBlock: "20px" }} />

            {loading ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <CircularProgress color="secondary" />
                </div>
            ) : (
                <List>
                    {roles.length > 0 ? (
                        roles
                            .filter((role) => role.name !== "uma_protection")
                            .map((role) => (
                                <ListItem key={role.id}>
                                    <ListItemText
                                        primary={<strong>{role.name}</strong>}
                                        secondary={role.description}
                                    />
                                </ListItem>
                            ))
                    ) : (
                        <Typography variant="body2" color="textSecondary">
                            No tiene roles asignados.
                        </Typography>
                    )}
                </List>
            )}
        </>
    );
}
